import React, {PureComponent, ReactNode} from "react"
import {Row, Col} from "react-bootstrap"
import {
  Label,
  Value
} from "./styled"

interface Props {
  label: string,
  value?: string,
  date?: ReactNode
}

export default class ValueLabel extends PureComponent<Props> {
  render() {
    const {label, value, date} = this.props
    return (
      <Row>
        <Col xs={12}>
          <Label>{label}</Label>
          {value && <Value>{value}</Value>}
          {date && <Value>{date}</Value>}
        </Col>
      </Row>
    )
  }
}
